<template>
  <sui-page>
    <sui-page-header :pageId="this.$options.name" />
    <sui-page-contents>
      <div class="comm_scr_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_MDLE')"
              :required="false"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-module-submodule-select
              ref="selectModule"
              :pageId="this.$options.name"
              :selectedMd="searchFrame.selectedCodeValue.moduleCode"
              :selectedSmd="searchFrame.selectedCodeValue.subModuleCode"
              :defaultMdOption="'all'"
              :defaultSmdOption="'all'"
              class="dp_flex"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_TRMT_TYPE')"
              :required="false"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-code-select
              ref="selectInterfaceTransmitTypeCode"
              :selected="searchFrame.selectedCodeValue.interfaceTransmitTypeCode"
              :pageId="this.$options.name"
              codeId="COD_IF_TRMT_TYPE"
              :defaultOption="'all'"
              :initialSelectedIndex="0"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_PROC_TYPE')"
              :required="false"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-code-select
              ref="selectInterfaceProcessTypeCode"
              :selected="searchFrame.selectedCodeValue.interfaceProcessTypeCode"
              :pageId="this.$options.name"
              codeId="COD_IF_PROC_TYPE"
              :defaultOption="'all'"
              :initialSelectedIndex="0"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_CONN_SYS_NM')"
              :required="false"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-text-field
              v-model.trim="searchFrame.interfaceConnectionSystemName"
              maxlength="50"
              @keyup.enter="onSearchClick"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_SEND_SYS_NM')"
              :required="false"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-text-field
              v-model.trim="searchFrame.interfaceSendSystemName"
              maxlength="50"
              @keyup.enter="onSearchClick"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_RECP_SYS_NM')"
              :required="false"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-text-field
              v-model.trim="searchFrame.interfaceReceiptSystemName"
              maxlength="50"
              @keyup.enter="onSearchClick"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_CONN_WAY')"
              :required="false"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <!-- <sui-text-field
              v-model.trim="searchFrame.interfaceWayName"
              maxlength="100"
            /> -->
            <sui-code-select
              ref="selectInterfaceWayName"
              :selected="searchFrame.selectedCodeValue.interfaceWayName"
              :pageId="this.$options.name"
              codeId="COD_IF_CONN_TYPE"
              :defaultOption="'all'"
              :initialSelectedIndex="0"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_SEARCH_COND')"
              :required="false"
              :vertical="false"
              class="ls"
            />
          </div>
          <div class="col-xs-7">
            <sui-code-select
              ref="selectInterfaceSearchCond"
              :selected="searchFrame.selectedCodeValue.interfaceSearchCond"
              :pageId="this.$options.name"
              codeId="COD_IF_SEARCH_COND"
              :defaultOption="'all'"
              :initialSelectedIndex="0"
              style="width:58.5%"
            />
            <div class="comp_spacing" />
            <sui-text-field
              v-model.trim="searchFrame.interfaceSearchWord"
              maxlength="50"
              @keyup.enter="onSearchClick"
            />
          </div>
        </div>
        <div class="btn_wrap">
          <sui-button
            v-permission:read="this.$options.name"
            type="button"
            class="comm_btn_Reset"
            @click="onResetClick"
          >
            {{ $t("MSG_BTN_RESET") }}
          </sui-button>
          <sui-button
            v-permission:read="this.$options.name"
            type="button"
            class="comm_btn_Scr"
            @click="onSearchClick"
          >
            {{ $t("MSG_BTN_SEARCH") }}
          </sui-button>
        </div>
      </div>
      <div class="mrB30" />
      <sui-grid
        ref="mainGrid"
        :dataset="'ds0'"
        :columns="gridColumns0"
        :showDisplayCountControl="false"
        :initial-pagesize="10"
        :multiselect="true"
      />
      <div class="comm_btn_wrap">
        <sui-button
          v-permission:delete="this.$options.name"
          type="button"
          class="comm_btn_border"
          @click="onDeleteClick"
        >
          {{ $t("MSG_BTN_DEL") }}
        </sui-button>
        <sui-button
          v-permission:create="this.$options.name"
          type="button"
          class="comm_btn_solid"
          @click="onNewAndCancelClick"
        >
          {{ $t("MSG_BTN_RGST") }}
        </sui-button>
      </div>
      <sui-popup
        v-model="isShownPopupNew"
        :title="$t('MSG_TIT_IF_RGST')"
      >
        <p01
          :pageId="this.$options.name"
          @onNewAndCancelClick="onNewAndCancelClick"
          @research="research"
        />
      </sui-popup>
      <sui-popup
        v-model="isShownPopupMod"
        :title="$t('MSG_TIT_IF_DTL')"
      >
        <p02
          :pageId="this.$options.name"
          :interfaceId="interfaceId"
          @onModAndCancelClick="onModAndCancelClick"
          @onHistoryListClick="onHistoryListClick"
          @research="research"
          @onDelete="deleteAction"
        />
      </sui-popup>
      <sui-popup
        v-model="isShownPopupHistory"
        :title="$t('MSG_TXT_IF_HIS_LIST')"
      >
        <p03
          :pageId="this.$options.name"
          :interfaceId="interfaceId"
          @onHistoryListClick="onHistoryListClick"
          @onHistoryDetailClick="onHistoryDetailClick"
        />
      </sui-popup>
    </sui-page-contents>
  </sui-page>
</template>
<script>
// import - libraries (node modules)
// import - local files (js, vue, ...)
import p01 from './components/PGE_CMS_00002_P01';
import p02 from './components/PGE_CMS_00002_P02';
import p03 from './components/PGE_CMS_00002_P03';
import BasePage from '~cm/components/BasePage';

export default {
  name: 'PGE_CMS_00002', // eslint-disable-line vue/name-property-casing
  components: {
    p01,
    p02,
    p03,
  },
  extends: BasePage,
  data() {
    return {
      searchFrame: {
        selectedCodeValue: {
          moduleCode: {
            key: '',
            label: '',
          },
          subModuleCode: {
            key: '',
            label: '',
          },
          interfaceTransmitTypeCode: {
            label: '',
            key: '',
          },
          interfaceProcessTypeCode: {
            label: '',
            key: '',
          },
          interfaceWayName: {
            label: '',
            key: '',
          },
          interfaceSearchCond: {
            label: '',
            key: '',
          },
        },
        interfaceConnectionSystemName: '',
        interfaceSendSystemName: '',
        interfaceReceiptSystemName: '',
        interfaceSearchWord: '',
      },
      localdata0: [],
      gridColumns0: [{
        text: this.$t('MSG_TXT_MDLE'),
        datafield: 'moduleName',
        width: '100px',
      }, {
        text: this.$t('MSG_TXT_SMDLE'),
        datafield: 'subModuleName',
        width: '100px',
      }, {
        text: this.$t('MSG_TXT_IF_ID'),
        datafield: 'interfaceId',
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellButton(row, column, value, htmlElement, {
            handler: this.onGridSingleButtonClicked,
            type: 'link',
          }, this.ds0, this.$refs.mainGrid);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
      }, {
        text: this.$t('MSG_TXT_IF_NM'),
        datafield: 'interfaceName',
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellButton(row, column, value, htmlElement, {
            handler: this.onGridSingleButtonClicked,
            type: 'link',
          }, this.ds0, this.$refs.mainGrid);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
      }, {
        text: this.$t('MSG_TXT_TRMT_TYPE'),
        datafield: 'interfaceTransmitTypeName',
      }, {
        text: this.$t('MSG_TXT_CONN_SYS_NM'),
        datafield: 'interfaceConnectionSystemName',
      }, {
        text: this.$t('MSG_TXT_SEND_SYS_NM'),
        datafield: 'interfaceSendSystemName',
      }, {
        text: this.$t('MSG_TXT_RECP_SYS_NM'),
        datafield: 'interfaceReceiptSystemName',
      }, {
        text: this.$t('MSG_TXT_PROC_TYPE'),
        datafield: 'interfaceProcessTypeName',
      }],
      isShownPopupNew: false,
      isShownPopupMod: false,
      isShownPopupHistory: false,
      interfaceId: '',
      clearFlag: false,
    };
  },
  watch: {
    // data 변경시 특정 함수를 호출 해야 하는 경우(async 등)
  },
  datasets: [{
    id: 'ds0',
    type: 'local',
    data: 'localdata0',
    datafields: [
      { type: 'string', name: 'deleteYn', map: 'deleteYn' },
      { type: 'string', name: 'firstRegistrationDTM', map: 'firstRegistrationDTM' },
      { type: 'string', name: 'firstRegistrationUserId', map: 'firstRegistrationUserId' },
      { type: 'string', name: 'firstRegistrationProgramId', map: 'firstRegistrationProgramId' },
      { type: 'string', name: 'finalModificationDTM', map: 'finalModificationDTM' },
      { type: 'string', name: 'finalModificationUserId', map: 'finalModificationUserId' },
      { type: 'string', name: 'finalModificationProgramId', map: 'finalModificationProgramId' },
      { type: 'string', name: 'session', map: 'session' },
      { type: 'string', name: 'originalFinalModificationDTM', map: 'originalFinalModificationDTM' },
      { type: 'string', name: 'interfaceId', map: 'interfaceId' },
      { type: 'string', name: 'interfaceName', map: 'interfaceName' },
      { type: 'string', name: 'moduleCode', map: 'moduleCode' },
      { type: 'string', name: 'subModuleCode', map: 'subModuleCode' },
      { type: 'string', name: 'interfaceSendSystemName', map: 'interfaceSendSystemName' },
      { type: 'string', name: 'interfaceReceiptSystemName', map: 'interfaceReceiptSystemName' },
      { type: 'string', name: 'interfaceProgramId', map: 'interfaceProgramId' },
      { type: 'string', name: 'interfaceContent', map: 'interfaceContent' },
      { type: 'string', name: 'interfaceConnectionSystemName', map: 'interfaceConnectionSystemName' },
      { type: 'string', name: 'interfaceConnectionId', map: 'interfaceConnectionId' },
      { type: 'string', name: 'interfaceWayName', map: 'interfaceWayName' },
      { type: 'string', name: 'interfaceTransmitTypeCode', map: 'interfaceTransmitTypeCode' },
      { type: 'string', name: 'interfaceDivisionCode', map: 'interfaceDivisionCode' },
      { type: 'string', name: 'interfaceCommunicationTypeCode', map: 'interfaceCommunicationTypeCode' },
      { type: 'string', name: 'interfaceProcessTypeCode', map: 'interfaceProcessTypeCode' },
      { type: 'string', name: 'interfaceCycleContent', map: 'interfaceCycleContent' },
      { type: 'string', name: 'interfaceDataFormatCode', map: 'interfaceDataFormatCode' },
      { type: 'string', name: 'moduleName', map: 'moduleName' },
      { type: 'string', name: 'subModuleName', map: 'subModuleName' },
      { type: 'string', name: 'interfaceTransmitTypeName', map: 'interfaceTransmitTypeName' },
      { type: 'string', name: 'interfaceDivisionName', map: 'interfaceDivisionName' },
      { type: 'string', name: 'interfaceCommunicationTypeName', map: 'interfaceCommunicationTypeName' },
      { type: 'string', name: 'interfaceProcessTypeName', map: 'interfaceProcessTypeName' },
      { type: 'string', name: 'interfaceDataFormatName', map: 'interfaceDataFormatName' },
    ],
  }],
  mounted() {
  },
  beforeDestroy() {
  },
  methods: {
    onResetClick() {
      utils.forEach(this.searchFrame, (text, key) => {
        if (!utils.isEqual(key, 'selectedCodeValue')) {
          this.searchFrame[key] = '';
        }
      });
      utils.forEach(this.$refs, (ref, key) => {
        if (utils.startsWith(key, 'select')) {
          ref.reset();
        }
      });
      this.$refs.selectModule.selectMd('ALL');
    },
    getSearchData() {
      const data = {};
      utils.forEach(this.searchFrame, (value, key) => {
        if (!utils.isEqual(key, 'selectedCodeValue')) {
          data[key] = value;
        } else {
          utils.forEach(value, (codeValue, codekey) => {
            data[codekey] = codeValue.key;
          });
        }
      });
      return data;
    },
    onSearchClick() {
      const queryParams = this.getSearchData();
      http.request(this.$options.name, 'DTS_CMS_00001', {
        query: queryParams,
      }).then(res => {
        this.ds0.setRawData(res.data);
      }).catch(error => {
        console.log(error);
      });
    },
    onNewAndCancelClick() {
      this.isShownPopupNew = !this.isShownPopupNew;
    },
    onModAndCancelClick(interfaceId) {
      if (!utils.isEmpty(interfaceId)) {
        this.interfaceId = interfaceId;
      } else {
        this.ds0.clearSelection();
      }
      this.isShownPopupMod = !this.isShownPopupMod;
    },
    onHistoryDetailClick(data) {
      utils.openLayerPopup('PGE_CMS_00008', () => {}, {
        pageInitialData: {
          interfaceData: data,
        },
        size: 'lg',
      });
    },
    onHistoryListClick() {
      this.isShownPopupHistory = !this.isShownPopupHistory;
    },
    onGridSingleButtonClicked(value, dataRow) {
      const { interfaceId } = dataRow;
      if (!utils.isEmpty(interfaceId)) {
        this.onModAndCancelClick(interfaceId);
      }
    },
    onDeleteClick() {
      const selected = this.ds0.getSelectedRawData();
      if (selected.length === 0) {
        utils.messageBox('warning', this.$t('MSG_ALT_DEL_DATA_SELT'));
      } else {
        const idList = utils.map(selected, 'interfaceId');
        this.deleteAction(idList);
      }
    },
    deleteAction(idList) {
      utils.messageBox('confirm', this.$t('MSG_ALT_DO_DELETE'), null, () => {
        http.request(this.$options.name, 'DTS_CMS_00027', {
          data: idList,
        }).then(() => {
          utils.messageBox('success', this.$t('MSG_ALT_DEL_DATA'), null, this.research);
        }).catch(error => {
          console.log(error);
        });
      });
    },
    research() {
      if (this.isShownPopupNew) {
        this.onNewAndCancelClick();
      }
      if (this.isShownPopupMod) {
        this.onModAndCancelClick();
      }
      this.onSearchClick();
    },
  },
};
</script>
<style scoped>
</style>
